/* unplugin-vue-components disabled */import { ElDatePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/date-picker/style/css';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  key: 0
};
import { reactive, watch } from "vue";
export default {
  __name: 'boardHeader',
  props: {
    title: {
      type: String,
      default: "最近30天登录情况概况"
    },
    modelValue: {
      type: Array,
      default: []
    },
    showTime: {
      type: Boolean,
      default: true
    }
  },
  emits: "update:modelValue",
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var timeranges_child = ref([]);
    watch(() => {
      return props.modelValue;
    }, () => {
      timeranges_child.value = props.modelValue;
    }, {
      immediate: true
    });
    watch(() => {
      return timeranges_child.value;
    }, val => {
      emit("update:modelValue", timeranges_child.value);
    });
    return (_ctx, _cache) => {
      var _component_el_date_picker = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1), __props.showTime ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_date_picker, {
        modelValue: _unref(timeranges_child),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(timeranges_child) ? timeranges_child.value = $event : timeranges_child = $event),
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        size: "small",
        style: {
          "width": "220px"
        }
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]);
    };
  }
};